import { Box, Button, Text } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";

const SocialLoginButton = (props: {
    icon:string;
    label:string;
    isMobile?:boolean;
    onClick:() => void;
}) => {
    const buttonRef : any = useRef(null);
    const [buttonWidth, setButtonWidth] = useState<number | null>(null);

    useEffect(() => {
        const updateButtonWidth = () => {
            if (buttonRef.current) {
                setButtonWidth(buttonRef.current.offsetWidth);
            }
        };

        // Initial update
        updateButtonWidth();

        // Update on window resize
        window.addEventListener('resize', updateButtonWidth);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('resize', updateButtonWidth);
        };
    }, []);


    const isMobile = (buttonWidth ?? 0) <= 148 || props.isMobile

    return <Button
        size='lg'
        justifyContent={isMobile ? 'center' : 'left'} gap='10px'
        variant='outline' ref={buttonRef}
        onClick={() => {
            props.onClick()
        }}
    >
        <Box 
            bgPos='center'
            bgSize='contain'
            bgRepeat='no-repeat'
            bgImage={props.icon} 
            w='27px' h='27px' 
            minW='27px'
        />
        {isMobile ? <></> :
            <>
                <Text w='calc(100% - 47px)' fontSize='md'>
                    {props.label}
                </Text>
            </>
        }


    </Button>
}

export default SocialLoginButton